<template>
  <div id="StudyFresKa" class="study">
    <div class="container-fluid head" style="background-color: #fd5050">
      <Header />

      <h1>Website Design for Fres-Ka</h1>
    </div>

    <div class="container">

      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/Fres-Ka/LogoBackground.png" width="90%" />
        </div>
        <div class="col-12 col-md-6">
          <h2>The Project</h2>
          <p>
            Fres-Ka is a Peruvian e-commerce website I have founded in 2019 that
            sells Korean beauty products.<br/>
            I built this website using WordPress and WooCommerce.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-12">
          <h2>The Problem</h2>
          <p>
            Fres-Ka has grown over the past few years and I have noticed the following issues:<br/><br/>
            <ul>
              <li>Growing amount of abandoned registration forms</li>
              <li>Disconnect between the brand personality versus the website</li>
              <li>Lengthy checkout and lack of reassurance</li>
              <li>Poor mobile registration and payment experience</li>
            </ul>
            To tackle these problems, I decided to entirely redesign the website and focused on improving the user flow from landing to checkout.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-12">
          <h2>Wireframing</h2>
          <p>
            I used Figma to wireframe each page of the website and design a new user flow. I reduced as much as I could the amount of user interaction to go from home page to payment.
          </p>
          <img src="/images/Fres-Ka/wireframe.png" width="100%" />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h2>Crafting a brand identity</h2>
          <p>
            The brand consists of a collection of gradients of red, white and pink to give a youthful and lively appearance.<br/><br/>
            For typography, I used a geometric sans serif font, Poppins, for headers and body text.
          </p>
          <br />
          <br />
          <img src="/images/Fres-Ka/typography.png" width="100%" />
          <img src="/images/Fres-Ka/colorguide.png" width="100%" class="mt-5" />
          <img src="/images/Fres-Ka/logovariations.png" width="100%" class="mt-5" />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h2>The Solution</h2>
          <img src="/images/Fres-Ka/ui_banner.png" width="100%" />
        </div>
      </div>

    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
export default {
  name: "StudyFresKa",
  components: { Header, Footer },
  data: function () {
    return {
      slides: [],
    };
  },
  methods: {},
  mounted: function () {},
};
</script>

<style lang="scss">
#StudyFresKa {
}
</style>